import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MessageCircle, Save } from "lucide-react";
import { useWhatsApp } from "@/context/WhatsAppContext";
import { buildWaLink } from "@/components/dashboard/WhatsAppButton";
import { toast } from "sonner";

export default function WhatsAppSettingsDialog({ open, onOpenChange }) {
  const { template, setTemplate } = useWhatsApp();
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setText(template || ""); }, [open, template]);

  const save = async () => {
    setSaving(true);
    try {
      await setTemplate(text);
      toast.success("Mensagem de WhatsApp guardada");
      onOpenChange(false);
    } catch (e) {
      toast.error("Erro ao guardar a mensagem");
    } finally {
      setSaving(false);
    }
  };

  const preview = buildWaLink("912345678", "Maria", text);
  const previewMsg = (text || "").replace(/\{nome\}/gi, "Maria");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#18181b] border border-[#3f3f46] rounded-none text-[#fafafa] max-w-lg" data-testid="whatsapp-settings">
        <DialogHeader>
          <DialogTitle className="font-head font-normal text-lg flex items-center gap-2">
            <MessageCircle className="w-5 h-5 text-[#25D366]" /> Mensagem de WhatsApp
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#a1a1aa]">
          Define a mensagem de saída usada no botão de WhatsApp dos perfis. Usa{" "}
          <code className="text-[#c8aa6e] bg-[#09090b] px-1 py-0.5">{"{nome}"}</code> para inserir o nome do perfil.
        </p>
        <textarea
          rows={4}
          value={text}
          onChange={(e) => setText(e.target.value)}
          data-testid="whatsapp-template-input"
          placeholder="Olá {nome}, vi o seu anúncio e gostaria de saber mais."
          className="w-full bg-[#09090b] border border-[#3f3f46] text-[#fafafa] px-3 py-2 text-sm outline-none focus:border-[#c8aa6e] resize-none"
        />
        <div className="bg-[#09090b] border border-[#27272a] px-3 py-2">
          <div className="label-tiny mb-1">Pré-visualização (perfil “Maria”)</div>
          <p className="text-sm text-[#d4d4d8]">{previewMsg || "—"}</p>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={() => onOpenChange(false)} className="px-4 py-2 text-sm border border-[#3f3f46] text-[#a1a1aa] hover:text-[#fafafa]">Cancelar</button>
          <button onClick={save} disabled={saving} data-testid="whatsapp-save" className="inline-flex items-center gap-1.5 px-4 py-2 text-sm bg-[#c8aa6e] text-black hover:bg-[#d4b982] disabled:opacity-60">
            <Save className="w-4 h-4" /> Guardar
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
